import { AxiosInstance, AxiosResponse } from 'axios';
import ColisportApiResource from './colisport-api-resource.model';
import { OfferOptionsRequestApi } from '../../models/offer-options-request-api.model';
import { DeliveryPrice } from '../../models/offer-option.model';

export interface RecapPriceRequest {
  offerType: string;
  pickUpDate?: string | null;
  offerPrice: number;
  assuranceTotalWithVAT: number;
  userEmail?: string | null;
  originCountry: string;
  isIndividualAccountType: boolean;
}

export interface RecapPriceResponse {
  pickupPartnerFeeDelta: number;
  totalPrice: number;
}

export default class OfferApi implements ColisportApiResource {
  readonly apiUrlPath = 'offer';

  constructor(readonly httpClient: AxiosInstance) {}

  getOffers(data: OfferOptionsRequestApi): Promise<AxiosResponse<DeliveryPrice[]>> {
    return this.httpClient.post(`${this.apiUrlPath}/calculate`, data);
  }

  recapPrice(data: RecapPriceRequest): Promise<AxiosResponse<RecapPriceResponse>> {
    return this.httpClient.post(`${this.apiUrlPath}/recap-price`, data);
  }

  isValidDate(): Promise<AxiosResponse<boolean>> {
    return this.httpClient.get(`${this.apiUrlPath}/isBefore17Pm`);
  }

  timeNow(): Promise<AxiosResponse<Date>> {
    return this.httpClient.get(`${this.apiUrlPath}/timeNow`);
  }
}
